
export default {
	isEnter(keyCode: number) {
		return keyCode === 13;
	},
	isDelete(keyCode: number) {
		return keyCode === 46;
	},
	isBackSpace(keyCode: number) {
		return keyCode === 8;
	},
	isArrowUp(keyCode: number) {
		return keyCode === 38;
	},
	isArrowDown(keyCode: number) {
		return keyCode === 40;
	},
	isArrowLeft(keyCode: number) {
		return keyCode === 37;
	},
	isArrowRight(keyCode: number) {
		return keyCode === 39;
	},
	isEsc(keyCode: number) {
		return keyCode === 27;
	},
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/keys.ts